import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { findMissionStatusLabel } from './findMissionStatusLabel';
import { Chip } from '@mui/material';
import { MissionStatus } from '@wwf/sdk';
import { useRecordContext } from 'react-admin';

export const MissionStatusChip = ({ status }: { status: MissionStatus }) => {
    const { missionStatusLabels } = useConfigurationContext();

    const label = findMissionStatusLabel(missionStatusLabels, status);
    return (
        <Chip
            label={label?.label}
            color={label?.color ?? 'error'}
            size="small"
        />
    );
};

/** Renders MissionStatusChip from react-admin choice record (`id` = status value). */
export const MissionStatusSelectOption = () => {
    const record = useRecordContext<{ id: MissionStatus; name: string }>();
    if (record?.id == null) return null;
    return <MissionStatusChip status={record.id} />;
};
